import { useT } from "@/i18n/LangProvider";

export default function BeforeAfter() {
  const { t } = useT();
  const left = t("beforeAfter.before") || [];
  const right = t("beforeAfter.after") || [];

  return (
    <section
      data-testid="before-after-section"
      className="grid grid-cols-1 md:grid-cols-2"
    >
      <div
        className="section py-20 px-8 md:px-16"
        style={{ background: "var(--navy-mid)" }}
      >
        <p className="eyebrow fade-up text-[color:var(--muted-white)]">
          {t("beforeAfter.before_eyebrow")}
        </p>
        <h3 className="font-serif text-3xl md:text-4xl mt-3 mb-10 text-[color:var(--white)] fade-up">
          {t("beforeAfter.before_title")}
        </h3>
        <ul className="space-y-5">
          {left.map((l, i) => (
            <li
              key={i}
              className="flex gap-4 items-start fade-up"
              data-testid={`before-item-${i}`}
            >
              <span
                className="font-mono-brand text-lg"
                style={{ color: "rgba(184,150,46,0.45)" }}
              >
                ✗
              </span>
              <span className="font-sans-brand text-[color:var(--muted-white)] leading-relaxed">
                {l}
              </span>
            </li>
          ))}
        </ul>
      </div>

      <div
        className="section py-20 px-8 md:px-16"
        style={{ background: "var(--navy-deep)" }}
      >
        <p className="eyebrow fade-up">{t("beforeAfter.after_eyebrow")}</p>
        <h3 className="font-serif text-3xl md:text-4xl mt-3 mb-10 text-[color:var(--white)] fade-up">
          {t("beforeAfter.after_title1")}{" "}
          <em className="text-[color:var(--gold-light)]">
            {t("beforeAfter.after_title_em")}
          </em>
        </h3>
        <ul className="space-y-5">
          {right.map((r, i) => (
            <li
              key={i}
              className="flex gap-4 items-start fade-up"
              data-testid={`after-item-${i}`}
            >
              <span className="font-mono-brand text-lg text-[color:var(--gold-light)]">
                ✓
              </span>
              <span className="font-sans-brand text-[color:var(--white)] leading-relaxed">
                {r}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
